import React from 'react'
import { ButtonLoadingSeeker, IconSeeker } from '@ui-seeker/core'
import { isCsvLoading } from '../../../../../@signals'
import { secondaryButtonSx } from '@components'


export default function UploadCsvTemplate() {


    return <ButtonLoadingSeeker
        variant="outlined"
        sx={secondaryButtonSx}
        startIcon={<IconSeeker icon="file-arrow-down"/>}
        loading={isCsvLoading.value}
        onClick={e => {
            e.preventDefault()
            window.open('https://storage.googleapis.com/price-seeker-rentacar-reports-custom-csv/CustomCsvReportsTemplate.csv')
        }}
        tooltip="Download example template for CSV"
    >
        Download example
    </ButtonLoadingSeeker>

}